import { z } from 'zod';

import { BorrowerId, WorkoutPlanId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateDefermentWorkoutPlanSideEffectContext = BaseLoanIdSideEffect.extend({
  borrowerIds: z.array(BorrowerId),
  workoutPlanId: WorkoutPlanId,
});

export const GenerateDefermentWorkoutPlanSideEffect = GenerateDefermentWorkoutPlanSideEffectContext.extend({
  type: z.literal('generateDefermentWorkoutPlan'),
});
export type GenerateDefermentWorkoutPlanSideEffect = z.infer<typeof GenerateDefermentWorkoutPlanSideEffect>;
